import _ from 'lodash'
const FORM_CUSTOMER_CONFIG = {
    form: _.select( '#form--customer' ),
    endpoint: 'contact/customer/'
}
export default FORM_CUSTOMER_CONFIG